module.exports = __webpack_public_path__ + "static/media/artificial_intelligence.f5577f56.svg";